import { styled } from "@mui/material/styles";
import MenuItem from '@mui/material/MenuItem';

export const StyledMenuItem = styled(MenuItem)`
root: {
    '&:focus': {
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: ${({ theme }) => theme.palette.primary.main},
      },
    },
  }
`;